import { RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "./index.css";
import router from "./routes/router";
import { Suspense } from "react";
import { useDispatch } from "react-redux";
import { setPopupState } from "reducer/globalSlice";
import SpinnerLoader from "components/UI/SpinnerLoader/SpinnerLoader";
import { NetworkProvider } from "context/NetworkContext";
import OfflineBanner from "components/UI/OfflineBanner/OfflineBanner";
import { GoogleOAuthProvider } from "@react-oauth/google";
import usePresenceHeartbeat from "hooks/usePresenceHeartbeat";

function App() {
  const dispatch = useDispatch();
  usePresenceHeartbeat();
  return (
    <GoogleOAuthProvider clientId="866508159589-v8tbt28756f5nfd166vk6clln8kam9og.apps.googleusercontent.com">
      <NetworkProvider>
        <div
          className="App"
          onClick={() => dispatch(setPopupState({ id: "", value: false }))}
        >
          <OfflineBanner />
          <Suspense
            fallback={
              <div
                style={{
                  width: "100%",
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <SpinnerLoader />
              </div>
            }
          >
            <RouterProvider router={router} />
          </Suspense>
          <Toaster
            position="top-center"
            reverseOrder={false}
            gutter={12}
            containerStyle={{ top: 18 }}
            toastOptions={{
              className: "qh-hot-toast",
              duration: 3200,
              style: {
                background: "transparent",
                boxShadow: "none",
                padding: 0,
                maxWidth: 420,
                color: "inherit",
              },
              success: {
                className: "qh-hot-toast qh-hot-toast--success",
                iconTheme: {
                  primary: "#6C63F5",
                  secondary: "#ffffff",
                },
              },
              error: {
                className: "qh-hot-toast qh-hot-toast--error",
                iconTheme: {
                  primary: "#f43f5e",
                  secondary: "#ffffff",
                },
              },
              loading: {
                className: "qh-hot-toast qh-hot-toast--loading",
              },
            }}
          />
        </div>
      </NetworkProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
